import { useEffect, useMemo, useState } from 'react';
import { setupAdCampaignsFromGoalTargets } from '../api/adsApi';
import { fetchCurrencyInfo } from '../api/currencyApi';
import { fetchEditableGoalTargetIds, fetchGoalTargets } from '../api/goalsApi';
import { LOADING_PERCENTAGE_60 } from '../constants/goals';
import { getGoalTargetCrmQuery } from '../utils/crmQueries';
import { logError } from '../utils/errorHandling';
import { getIsMarketingGoal } from '../utils/goalConfig';
import { getGoalTargets, getGoalTargetsWithPermissions } from '../utils/goalTarget';
export function useFetchGoalTargets(goalsTableProps, selectedSortDirection, numGoalTargetsPerPage, selectedSortColumn) {
  const [goalTargets, setGoalTargets] = useState(new Array());
  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [tableLoadingPercentage, setTableLoadingPercentage] = useState();
  const {
    goalType,
    status,
    milestone,
    percentProgressRange,
    endDateRange,
    adAccounts
  } = goalsTableProps;
  const memoizedAdAccountsForDependencyArray = useMemo(() => JSON.stringify(adAccounts), [adAccounts]);
  const memoizedStatusForDependencyArray = useMemo(() => JSON.stringify(status), [status]);
  const memoizedMilestonesForDependencyArray = useMemo(() => JSON.stringify(milestone), [milestone]);
  const isMarketingGoal = getIsMarketingGoal(goalType);
  useEffect(() => {
    setGoalTargets(new Array());
    const dataQuery = getGoalTargetCrmQuery({
      goalType,
      status,
      milestone,
      percentProgressRange,
      endDateRange,
      adAccounts
    }, offset, numGoalTargetsPerPage);
    setTableLoadingPercentage(1);
    Promise.all([fetchCurrencyInfo(), fetchGoalTargets(dataQuery, selectedSortColumn, selectedSortDirection)]).then(([currencyData, goalTargetData]) => {
      const currency = currencyData.homeCurrency.currencyCode;
      setTableLoadingPercentage(LOADING_PERCENTAGE_60);
      const targets = getGoalTargets(goalTargetData, currency);
      setGoalTargets(targets);
      setTotal(goalTargetData && goalTargetData.total || 0);
      return targets;
    }).then(targets => {
      if (!targets || !targets.length) return;
      const goalTargetIds = targets.map(target => target.objectId).join(',');
      const query = {
        goalTargetIds,
        goalType
      };
      Promise.all([setupAdCampaignsFromGoalTargets(targets), fetchEditableGoalTargetIds(query)]).then(([goalTargetsFromCampaignRequest, permissionResults]) => {
        setTableLoadingPercentage(99.99);
        const goalTargetsWithPermissions = getGoalTargetsWithPermissions(goalTargetsFromCampaignRequest, permissionResults);
        setGoalTargets(goalTargetsWithPermissions);
      }).catch(logError);
    }).catch(logError);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [numGoalTargetsPerPage, offset, selectedSortColumn, selectedSortDirection, endDateRange, goalType, percentProgressRange, isMarketingGoal, memoizedAdAccountsForDependencyArray, memoizedMilestonesForDependencyArray, memoizedStatusForDependencyArray]);
  return {
    goalTargets,
    total,
    setOffset,
    tableLoadingPercentage
  };
}